import { render, staticRenderFns } from "./IconUserGroupSolid.vue?vue&type=template&id=70923bb4"
import script from "./IconUserGroupSolid.vue?vue&type=script&lang=js"
export * from "./IconUserGroupSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports